/** @format */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';

import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import GridContainer from '../../../components/Grid/GridContainer';
import SearchBar from 'material-ui-search-bar';

import I18n from '../../../components/Translate/I18n';
import I18nSimple from '../../../core/i18n';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import DialogContent from '@material-ui/core/DialogContent';
import GridItem from '../../../components/Grid/GridItem';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import Pager from '../../../components/Adescom/Pager';
import { ipActions, ipConstants } from '../../../modules/ip/actions';
import TouchButton from '../../../components/Buttons/TouchButton';
import { store } from '../../../core/store';
import { ipReducers } from '../../../modules/ip/reducers';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { ReactComponent as Cancel } from '../../../assets/themes/OPL/img/icons/Cancel.svg';

const _ = require('underscore');

class IpPoolDialog extends PureComponent {
    constructor(props) {
        super(props);
        store.injectReducer('ipReducers', ipReducers);
        this.elementPerPage = 10;

        this.state = {
            search: '',
            filter: this.updateFilters(this.props.apnNameId),
            orders: [{ name: 'id', value: 'desc' }],
            ipList: null,
        };
    }

    updateFilters = (apnNameId) => {
        const { platformReseller } = this.props;
        const filter = [
            { name: 'itemsPerPage', value: this.elementPerPage },
            { name: 'ipState', value: 0 },
            { name: 'deleted', value: false },
            { name: 'apnName.id', value: apnNameId },
        ];
        if (platformReseller) {
            filter.push({
                name: 'ownerPlatformResellerId',
                value: platformReseller.id,
            });
        }
        return filter;
    };

    componentDidMount() {
        this.init();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { apnNameId } = this.props;
        if (prevProps.apnNameId !== apnNameId) {
            this.setState({ filter: this.updateFilters(apnNameId) }, this.init);
        }
    }

    init = () => {
        this.loadIps(this.state.filter);
    };

    loadIps = (searchOptions = null) => {
        const { dispatch } = this.props;
        const { orders } = this.state;
        const itemsLoader = new ItemLoaders(dispatch);
        itemsLoader.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_ip_pool_numbers')),
            'platform_ip_pools_choose_dialog_loader',
            searchOptions,
            orders,
            (data) => {
                this.setState({ ipList: data });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    onPaginationSearch = (uri) => {
        const { dispatch } = this.props;
        dispatch(ipActions.getList(FormGeneralHelper.getByUri(uri), this.state.filter, this.state.orders, ipConstants.LIST_POOL));
    };

    searchBarOnChangeCallback = (e) => {
        this.setState({
            search: e,
        });
    };

    handleSelectIpPool = (data) => {
        this.props.callbackChangeIp(data);
        if (this.props.disregardParentComponentReinit) {
            this.props.callbackClose();
        }
    };

    onCancelSearch = () => {
        const { apnNameId } = this.props;
        if (this.state.search.length > 0) {
            this.setState(
                {
                    search: '',
                    filter: this.updateFilters(apnNameId),
                },
                this.init
            );
        }
    };

    onRequestSearch = () => {
        const filter = this.state.filter;
        filter.push({ name: 'ip', value: this.state.search });
        this.loadIps(filter);
    };

    render() {
        const { classes, open, callbackClose, apnName } = this.props;
        const { ipList } = this.state;
        const tableCellRoot = { root: classes.tableCellRoot };

        if (ipList) {
            return (
                <Dialog
                    fullWidth={true}
                    maxWidth="sm"
                    open={open}
                    keepMounted
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">
                        <GridContainer justifyContent={'space-between'}>
                            <h4>
                                <I18n trans={'pools:pool.ip_pool_number'} />
                                <br />
                                {apnName}
                            </h4>
                            <Button onClick={callbackClose} color="primary">
                                <Cancel width={24} height={24} />
                            </Button>
                        </GridContainer>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description" />
                        <GridContainer>
                            <GridItem xs={12}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={4}>
                                                <Paper>
                                                    <SearchBar
                                                        value={this.state.search}
                                                        onCancelSearch={this.onCancelSearch}
                                                        onChange={this.searchBarOnChangeCallback}
                                                        onRequestSearch={this.onRequestSearch}
                                                        placeholder={I18nSimple.t('pools:search.ip')}
                                                        style={{
                                                            margin: '0 auto',
                                                        }}
                                                    />
                                                </Paper>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell padding="none" align="center" classes={tableCellRoot}>
                                                <I18n trans="pools:pool.ip_number" />
                                            </TableCell>
                                            <TableCell padding="none" align="center" classes={tableCellRoot}>
                                                <I18n trans="pools:pool.mask" />
                                            </TableCell>
                                            <TableCell padding="none" align="right" classes={tableCellRoot}>
                                                <I18n trans="general:common.commands" />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {ipList &&
                                            ipList['hydra:member'].map((row) => {
                                                return (
                                                    <TableRow key={row.id}>
                                                        <TableCell align="center" classes={tableCellRoot}>
                                                            {row.ip}
                                                        </TableCell>
                                                        <TableCell align="center" classes={tableCellRoot}>
                                                            {row.mask}
                                                        </TableCell>
                                                        <TableCell align="right" classes={tableCellRoot}>
                                                            <TouchButton
                                                                color="info"
                                                                tooltipTitle="pools:pool.choose_pools"
                                                                tooltipPlacement="left"
                                                                callback={this.handleSelectIpPool}
                                                                callbackParam={{
                                                                    item: row,
                                                                    isPrivate: row.private,
                                                                    uri: row['@id'],
                                                                }}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                    </TableBody>
                                    <TableFooter>
                                        <TableRow>
                                            <TableCell colSpan={5} className={classes.center}>
                                                {ipList && ipList['hydra:view'] && (
                                                    <Pager callback={this.onPaginationSearch} views={ipList['hydra:view']} />
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </GridItem>
                        </GridContainer>
                    </DialogContent>
                </Dialog>
            );
        } else {
            return (
                <GridContainer justify="center">
                    <CircularProgress />
                </GridContainer>
            );
        }
    }
}
IpPoolDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    open: PropTypes.bool,
    callbackClose: PropTypes.func.isRequired,
    platformReseller: PropTypes.object.isRequired,
    disregardParentComponentReinit: PropTypes.bool,
    callbackChangeIp: PropTypes.func,
    apnNameId: PropTypes.number.isRequired,
    apnName: PropTypes.string.isRequired,
};
const mapStateToProps = (state) => {
    return { ...state };
};
const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(IpPoolDialog);
export default Enhance;
